module.exports = __webpack_public_path__ + "img/31.1e1cf08e.jpg";